import { render } from "./ContratView.vue?vue&type=template&id=7cd04745"
import script from "./ContratView.vue?vue&type=script&lang=js"
export * from "./ContratView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__